import React, { useState, useEffect, useRef } from "react";

import api from "../services/api";
import useAxios from "../hooks/useAxios";
import axiosInstance from "../apis/gvmdesk";
import openToast from "../utils/sweetAlert";
import useLocalStorage from "use-local-storage";


//Momentjs
import moment from "moment";
import "moment/locale/pt-br";

import { useForm } from "react-hook-form";
import { useAuth } from "../providers/auth";
import { Link, useNavigate } from "react-router-dom";
import { CAlert, CAlertHeading, CButton } from "@coreui/react";
import { CSpinner, CPagination, CPaginationItem } from "@coreui/react";
import { Edit2, Phone, Search, Upload, AlertTriangle, Filter } from "react-feather";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

//Components
import Any from "../svgs/Any";
import Box from "../components/Box";
import Input from "../components/Input";
import Popup from "../components/Popup";
import Button from "../components/Button";
import UserCol from "../components/UserCol";
import Textarea from "../components/Textarea";
import NewInput from "../components/NewInput";
import PopupBody from "../components/PopupBody";
import PopupTags from "../components/PopupTags";
import PopupFixed from "../components/PopupFixed";
import PopupFooter from "../components/PopupFooter";
import PhoneNumber from "../components/PhoneNumber";
import DocDropzone from "../components/DocDropzone";
import PopupChatTags from "../components/PopupChatTags";
import CustomerTable from "../components/CustomerTable";
import BoxCustomerMenu from "../components/BoxCustomerMenu";
import PopupSocialMedia from "../components/PopupSocialMedia";
import PopupLastAccesses from "../components/PopupLastAccesses";
import LoadingCenter from "../components/LoadingCenter";
import PopupTransferCustomer from "../components/PopupTransferCustomer";
import InputControlledMask from "../components/Forms/InputControlledMask";
import PopupAdvancedSearchProspect from "../components/PopupAdvancedSearchProspect";
import PopupJoinCustomers from "./PopupJoinCustomers";
import PopupJoinCustomersChoice from "./PopupJoinCustomersChoice";
import ChartHours from "../components/ChartHours";
import { useMutation } from "@tanstack/react-query";
import PopupSelectSocialMedia from "../components/PopupSelectSocialMedia";
import { useHttp } from "../hooks/useHttp";
import { Spinner } from "../components";
import PopupSelectPhone from "../components/PopupSelectPhone";
import SocialMediaUser from "../components/SocialMediaUser";
import useMediaType from "../hooks/useMediaType";

const schema = yup.object({
  command: yup.string().required("O campo comando precisa ser preenchido!").matches(/^\S+$/, "O comando não pode conter espaços em branco."),
  body: yup.string().required("O campo texto precisa ser preenchido!")
}).required();

const observationSchema = yup.object({
  observation: yup.string().required("Você precisa informar a observação acima!")
}).required();

const advancedSearchSchema = yup.object({
  email: yup.string().email(),
  cpf: yup.string()
});

function Customers() {
  const { register: registerObservation, handleSubmit: handleSubmitObservation, reset, formState: { errors: errorsObservation } } = useForm({
    resolver: yupResolver(observationSchema)
  });

  const currentChat = useRef(null);
  const inputFilesRef = useRef(null);
  const currentCustomer = useRef(null);

  const { user } = useAuth();

  const [buttonPopupLastAccesses, setButtonPopupLastAccesses] = useState(false);
  const [search, setSearch] = useState("");

  const [info, setInfo] = useState();
  const [infoLoading, setInfoLoading] = useState(false);

  const [customers, setCustomers] = useState([]);
  const [customersLoading, setCustomersLoading] = useState(true);

  const [buttonPopupTags, setButtonPopupTags] = useState(false);
  const [buttonPopupTagsUser, setButtonPopupTagsUser] = useState(false);
  const [buttonPopupChatTags, setButtonPopupChatTags] = useState(false);
  const [buttonPopupSocialMedia, setButtonPopupSocialMedia] = useState(false);
  const [previous, setPrevious] = useState(true);
  const [next, setNext] = useState(false);

  const [buttonPopupSocialMediaFilter, setButtonPopupSocialMediaFilter] = useState(false);


  const [qtdPag, setQtdPag] = useState("");
  const numberPage = useRef(1);


  async function setLastAccess(id) {
    try {
      const response = await api.get(`/users/last/access/` + id, { headers: { "Authorization": "Bearer " + user.token } });
      setCustomers(response.data.dados);
      setButtonPopupTags(false);
      setButtonPopupSocialMedia(false);
      setButtonPopupLastAccesses(false);
    } catch (err) {
      console.log(err);
    }
  }


  async function fetchCustomers() {
    const options = { headers: { "Authorization": "Bearer " + user.token } };

    setCustomersLoading(true);

    try {
      const response = await api.get("/users/admin/allsl", options);

      setCustomers(response.data.dados);
      setQtdPag(response.data.qtd);

    } catch (error) {
      console.log(error);
    } finally {
      setCustomersLoading(false);
    }
  }

  async function fetchCustomerById(id) {
    currentChat.current = { id: id };

    const options = { headers: { "Authorization": "Bearer " + user.token } };

    try {
      setInfoLoading(true);
      const response = await api.get("/users/" + id, options);

      setInfo(response.data);
      currentCustomer = response.data.juridic;
    } catch (error) {
      console.log(error);
    } finally {
      setInfoLoading(false);
    }
  }

  useEffect(() => {
    fetchCustomers();
  }, []);

  //MEDIAS/TAGS
  const [media, setMedia] = useState("");
  const [access, setAccess] = useState("");
  const [tags, setTags] = useState([]);

  async function handleSearch(e) {
    if (e.key === "Enter") {
      setCustomersLoading(true);
      try {
        const response = await api.get(`/users/customers?tags_id=${tags}&social_media=${media}&search=${search}`, { headers: { "Authorization": "Bearer " + user.token } });

        setCustomers(response.data);
      } catch (error) {
        console.log(error);
      } finally {
        setCustomersLoading(false);
      }
    }
  }

  const fetchCustomersWithFilter = async () => {
    setCustomersLoading(true);

    try {
      const response = await api.get(`/users/customers?tags_id=${tags}&social_media=${media}&search=${search}`, { headers: { "Authorization": "Bearer " + user.token } });

      setCustomers(response.data);
      setButtonPopupTags(false);
      setButtonPopupSocialMedia(false);
      setButtonPopupLastAccesses(false);
    } catch (err) {
      console.log(err);
    } finally {
      setCustomersLoading(false);
    }
  }

  useEffect(() => {
    if (tags.length) fetchCustomersWithFilter();
  }, [tags]);

  useEffect(() => {
    if (media !== "") fetchCustomersWithFilter();
  }, [media]);

  useEffect(() => {
    if (access !== "") fetchCustomersWithFilter();
  }, [access]);

  const [buttonPopupObs, setButtonPopupObs] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const [obsLoading, setObsLoading] = useState(false);

  async function editObservation(data) {
    setObsLoading(true);

    try {
      const response = await api.post("/users/observation", { body: data.observation, user_id: info.id }, { headers: { "Authorization": "Bearer " + user.token } });

      if (!response.data.error) {
        openToast("success", "Sucesso", response.data.message);

        setButtonPopupObs(false);
        reset();
        const user_do_chat = await api.get(`/users/${info.id}`, { headers: { "Authorization": "Bearer " + user.token } });
        setInfo(user_do_chat.data);
      }

      if (response.data.error) {
        openToast("error", "Erro", response.data.message);
      }
    } catch (error) {
      openToast("error", "Erro", "Ocorreu um erro na sua solicitação.");
      setButtonPopupObs(false);
    } finally {
      setObsLoading(false);
    }
  }

  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [facebookNumber, setFacebookNumber] = useState("");
  const [instagramNumber, setInstagramNumber] = useState("");

  /**
   *
   * Juntar clientes
   */
  const [buttonJoinClients, setButtonJoinClients] = useState(false);
  const [buttonJoinInfo, setButtonJoinInfo] = useState(false);

  const { register, handleSubmit } = useForm();

  const { register: registerFiler, handleSubmit: handleSubmitFiler, formState: { errors } } = useForm({ resolver: yupResolver(schema) });

  const { register: registerSearch, handleSubmit: handleSubmitSearch, control, formState: { errors: errorsSearch } } = useForm();

  const [buttonPopupLigar, setButtonPopupLigar] = useState(false);
  const [listPhones, setListPhones] = useState([]);
  const [infoLoadingLigar, setInfoLoadingLigar] = useState(false);

  // LIGAR
  async function pegaCliente(id) {
    const options = { headers: { "Authorization": "Bearer " + user.token } };
    try {
      setInfoLoadingLigar(true);
      const response = await api.get("/users/list/phone/" + id, options);
      setListPhones(response.data);

    } catch (error) {
      console.log(error);
    } finally {
      setInfoLoadingLigar(false);
    }
  }

  async function setNumber(data) {
    setError("");

    try {
      const response = await api.post("/calls/ligarsl", { user_id: info.id, phone: data.number }, { headers: { "Authorization": "Bearer " + user.token } });

      if (response.data.error == true) {
        setError(response.data.message);
      }

    } catch (e) {
      console.log(e);
    }
  }

  function onSubmitJoinUsers(data) {


    setButtonJoinClients(false);
    setButtonJoinInfo(true);
  }

  const [selectedCustomer, setSelectedCustomer] = useState(false);
  const [selectedCustomerJoin, setSelectedCustomerJoin] = useState(false);
  const [selectedCustomerJoinChoice, setSelectedCustomerJoinChoice] = useState(false);
  const [popupSelectedCustomerJoinChoice, setPopupSelectedCustomerJoinChoice] = useState(false);


  /**
   *
   * quais vão ser os dados q tu vai precisar:
    {
        "id_base": 74,
        "id_delete": 4,
        "name": "novo name",
        "nickname": "nickname",
        "cpf": "100.225.455-5",
        "rg": 65486486,
        "city": 4440,
        "state": 8,
        "email": "teste@teste.com.br",
        "profile_pic": "https://huuhdfsdf/jisdfidsf.png",
        "usadao_id": "154891788",
        "phones":
            [
                55998847467,
                55993837377,
                55893489348
            ],
        "Whatsapp": 5641561561,
        "Facebook": 463456346,
        "Instagram": 4567567456,
        "Telegram": 86484894
    }
   */

  const editInfoAdmin = async () => {
    const user_do_chat = await api.get(`/users/${info.id}`, { headers: { "Authorization": "Bearer " + user.token } });
    setInfo(user_do_chat.data);
  }

  const [toggleAdvancedFilter, setToggleAdvancedFilter] = useState(false);
  const [filterLoading, setFilterLoading] = useState(false);

  const advancedFilter = (e) => {
    e.preventDefault();
    setToggleAdvancedFilter(true);
  }

  const searchAdvancedFilter = async data => {
    setFilterLoading(true);

    const { cpf, rg, email } = data;

    try {
      const response = await api.get(`/users/search/busca/avancada?cpf=${cpf || ""}&rg=${rg || ""}&email=${email || ""}`, { headers: { "Authorization": "Bearer " + user.token } });

      if (response.data.error) {
        openToast("info", "Ocorreu um erro", response.data.message);
      }

      if (!response.data.error) {
        setCustomers(response.data);
      }

    } catch (error) {
      if (error.response.data.error) {
        openToast("info", "Ocorreu um erro", error.response.data.message);
      }
    } finally {
      setFilterLoading(false);
      setToggleAdvancedFilter(false);
    }
  }

  /**
   *
   *
   */
  const navigate = useNavigate();

  const openCustomersDetails = (e, customer) => {
    e.preventDefault();
    navigate(`/customers/${customer.id}/`, { state: { title: customer.name } });
  }

  /**
   *
   * Clientes importantes
   */
  const [importants, setImportants, importantLoading, importantErrors, refetch] = useAxios({
    axiosInstance,
    method: "GET",
    url: "/users/important"
  });

  const [theme] = useLocalStorage("theme");

  const isDarkMode = theme === "dark";

  const paginationStyle = {
    "--cui-pagination-disabled-bg": isDarkMode ? "#2F3136" : "",
    "--cui-pagination-disabled-border-color": isDarkMode ? "#2F3136" : "",
    "--cui-pagination-bg": isDarkMode ? "#27282C" : ""
  };

  const [toggleTransfer, setToggleTransfer] = useState(false);
  const [customer, setCustomer] = useState(null);

  const transferCustomer = customer => {
    setCustomer(customer);
    setToggleTransfer(!toggleTransfer);
  }

  const [advancedSearch, setAdvancedSearch] = React.useState(false);

  /**
   *
   *
   *
   *
   * Botão de criar novo chat
   */
  const request = useHttp();

  const { register: registerMedia, handleSubmit: handleSubmitMedia, reset: resetMedia } = useForm();
  const { register: registerPhone, handleSubmit: handleSubmitPhone, reset: resetPhone } = useForm();

  const [mediaTrigger, setMediaTrigger] = useState(false);
  const [phoneTrigger, setPhoneTrigger] = useState(false);
  const [customerId, setCustomerId] = useState("");
  const [callId, setCallId] = useState("");
  const [callTrigger, setCallTrigger] = useState(false);
  const [feedbackBttn, setFeedbackBttn] = useState(false);

  // Retorna as redes sociais do cliente com base no id passado
  const socialMediaMutation = useMutation({
    mutationKey: ["socialMedias"],
    mutationFn: id => request({ url: "/users/socialmedia/" + id, method: "GET" })
  });

  // Pega o cliente
  const customerHandleMutation = useMutation({
    mutationKey: ["customerHandle"],
    mutationFn: id => request({ url: "/users/list/phone/" + id, method: "GET" }), // customer.id
    onSuccess: response => console.log(response.data)
  });

  // Assume o cliente
  const takeOnCustomerMutation = useMutation({
    mutationKey: ["takeOnCustomer"],
    mutationFn: media => request({ url: "/chats/novosl", method: "POST", data: { social_media: media, user_id: customerId } }),
    onSuccess: response => {
      if (response.data.error) {
        openToast("error", "Ocorreu um erro", response.data.message);
        return;
      }

      setMediaTrigger(false);
      setCallId("");
      resetMedia();
      fetchCustomers();
      openToast("success", "Sucesso", response.data.message);
    },
    onError: error => {
      openToast("error", "Ocorreu um erro", error.response?.data?.message || "Nao foi possivel abrir o chat para voce.");
    }
  });

  // Ligar
  const callMutation = useMutation({
    mutationFn: number => request({ url: "/calls/ligarsl", method: "POST", data: { user_id: customerId, phone: number, outdated: true } }),
    onSuccess: response => {
      if (response.data.error) {
        openToast("error", "Ocorreu um erro", response.data.message);
      }

      if (!response.data.error) {
        setCallId(response.data.call_id);
        setPhoneTrigger(false);
        setCallTrigger(true);

        setTimeout(() => {
          setFeedbackBttn(true);
        }, 10000);
      }
    }
  });

  const handleSetMedia = data => takeOnCustomerMutation.mutate(data.social_media);

  const handleSetNumber = data => callMutation.mutate(data.number);

  const { getMediaType } = useMediaType();

  return (
    <div className="customer-grid">
      {/* <Popup title="Unificar clientes" trigger={buttonJoinClients} setTrigger={setButtonJoinClients}>
        <div className="x-p-20 y-p-20">
          <span className="text-color">
            Selecione o cliente que você deseja unir com o cliente <span className="text-medium">"{selectedCustomer.name}"</span>.
          </span>
        </div>
      </Popup> */}
      <PopupSelectSocialMedia trigger={mediaTrigger} setTrigger={setMediaTrigger}>
        {socialMediaMutation.isLoading && <LoadingCenter />}
        {!socialMediaMutation.isLoading && <form onSubmit={handleSubmitMedia(handleSetMedia)}>
          <div className="row-grid">
            {socialMediaMutation.data?.data.map((media, index) => {
              return (
                <SocialMediaUser key={index} title={media} name="social_media" value={media} register={registerMedia} >
                  {getMediaType(media)}
                </SocialMediaUser>
              );
            })}
          </div>
          <div className="popup-footer">
            <button className="btn btn-primary" type="submit">
              {takeOnCustomerMutation.isLoading ? <Spinner /> : "Concluir"}
            </button>
            <button className="btn btn-light mr-20" type="button" onClick={() => setMediaTrigger(false)}>Cancelar</button>
          </div>
        </form>}
      </PopupSelectSocialMedia>

      <PopupSelectPhone trigger={phoneTrigger} setTrigger={setPhoneTrigger}>
        {customerHandleMutation.isLoading && <LoadingCenter />}
        <form onSubmit={handleSubmitPhone(handleSetNumber)}>
          <div className="row-grid">
            {!customerHandleMutation.isLoading &&
              customerHandleMutation.data?.data.map((phone, index) => {
                return (
                  <PhoneNumber key={index} title={phone.name} name="number" value={phone.name} qtd={phone.qtd} lastOne={String(phone.lastOne)} register={registerPhone} />
                );
              })}
          </div>
          <div className="popup-footer">
            <button className="btn btn-primary" type="submit" disabled={customerHandleMutation.isLoading}>
              {callMutation.isLoading ? <Spinner /> : "Ligar"}
            </button>
          </div>
        </form>
      </PopupSelectPhone>

      <PopupJoinCustomers trigger={buttonJoinClients} setTrigger={setButtonJoinClients} setPopupSelectedCustomerJoinChoice={setPopupSelectedCustomerJoinChoice} customer={selectedCustomer} customers={customers} setSelectedCustomerJoin={setSelectedCustomerJoin} />

      <PopupJoinCustomersChoice trigger={popupSelectedCustomerJoinChoice} setTrigger={setPopupSelectedCustomerJoinChoice} customers={{ selectedCustomer, selectedCustomerJoin }} />

      <PopupAdvancedSearchProspect trigger={advancedSearch} setTrigger={setAdvancedSearch} />

      <PopupTransferCustomer customer={customer} trigger={toggleTransfer} setTrigger={setToggleTransfer} onSuccess={fetchCustomers} />

      <PopupChatTags title="Gerenciar tags" info={info} trigger={buttonPopupTagsUser}
        setTrigger={setButtonPopupTagsUser} editInfoAdmin={editInfoAdmin} chat={currentChat} />

      <Popup title="Filtro avançado" trigger={toggleAdvancedFilter} setTrigger={setToggleAdvancedFilter} >
        <div className="u-padding-20-all" style={{ paddingTop: "0px" }}>
          <form onSubmit={handleSubmitSearch(searchAdvancedFilter)}>
            {/* cpf, rg, e-mail */}

            <Input label="Cpf" name="cpf" type="text"
              placeholder="00000000000" error={errorsSearch.cpf} register={registerSearch} />

            <Input label="Rg" name="Rg" type="text"
              placeholder="00000000000" error={errorsSearch.rg} register={registerSearch} />

            <Input label="E-mail" name="email" type="text"
              placeholder="00000000000" error={errorsSearch.email} register={registerSearch} />

            <div className="mt-20"></div>
            <Button title="Pesquisar" type="submit" color="green" width="full" loading={filterLoading} onClick={() => { }} />
          </form>
        </div>
      </Popup>

      <Popup title="Selecionar telefone" trigger={buttonPopupLigar} setTrigger={setButtonPopupLigar} >
        {infoLoadingLigar ?
          (
            <LoadingCenter />
          ) : (

            <form onSubmit={handleSubmit(setNumber)}>
              <div className="padding-inner" style={{ paddingTop: "0px" }}>

                {infoLoading ? (
                  <LoadingCenter />
                ) : (
                  <div className="sm-body">
                    <div className="row-grid">
                      {listPhones.map((phone, index) => {
                        return (
                          <PhoneNumber key={index} title={phone.name} name="number" value={phone.name} qtd={phone.qtd} lastOne={String(phone.lastOne)} register={register} />
                        )
                      })}
                    </div>
                  </div>
                )}

                {error ? (
                  <div className="mt-20 d-flex flex-row justify-content-center align-center" style={{ color: "red" }}>
                    {error}
                  </div>
                ) : (
                  ""
                )}

              </div>

              <div className="padding-lbr">
                <Button title="Ligar" type="submit" color="green" width="full" loading={false} />
              </div>
            </form>
          )}
      </Popup>

      {/* {
        {
            "id_base": 74,
            "id_delete": 4,
            "name": "novo name",
            "nickname": "nickname",
            "cpf": "100.225.455-5",
            "rg": 65486486,
            "city": 4440,
            "state": 8,
            "email": "teste@teste.com.br",
            "profile_pic": "https://huuhdfsdf/jisdfidsf.png",
            "usadao_id": "154891788",
            "phones":
                [
                    55998847467,
                    55993837377,
                    55893489348
                ],
            "Whatsapp": 5641561561,
            "Facebook": 463456346,
            "Instagram": 4567567456,
            "Telegram": 86484894
        }
      } */}
      <PopupTags setSelectedTags={setTags} trigger={buttonPopupTags} setTrigger={setButtonPopupTags} />

      <PopupSocialMedia setSelectedMedia={setMedia} trigger={buttonPopupSocialMediaFilter} setTrigger={setButtonPopupSocialMediaFilter} />

      <PopupChatTags title="Gerenciar tags" info={info} trigger={buttonPopupChatTags} setTrigger={setButtonPopupChatTags} editInfoAdmin={editInfoAdmin} chat={currentChat} />

      <Popup title="Editar observação" trigger={buttonPopupObs} setTrigger={setButtonPopupObs} >
        <form onSubmit={handleSubmitObservation(editObservation)}>
          <div className="padding-inner" style={{ paddingTop: "0px" }}>
            <Textarea label="Observação" type="text" placeholder=""
              name="observation" error={errorsObservation.error} register={registerObservation} />
          </div>

          <div className="padding-lbr">
            <Button title="Salvar" type="submit" color="green" width="full" loading={obsLoading} />
          </div>
        </form>
      </Popup>

      <Popup title="Redes sociais" trigger={buttonPopupSocialMedia} setTrigger={setButtonPopupSocialMedia}>
        <form onSubmit={handleSubmit(editObservation)}>
          {success && <div style={{ paddingLeft: "20px", paddingRight: "20px" }} className="mb-10 mt-10">{success}</div>}
          {error && <div style={{ paddingLeft: "20px", paddingRight: "20px" }} className="mb-10 mt-10">{error}</div>}

          <div className="padding-inner" style={{ paddingTop: "0px", paddingBottom: "0px" }}>
            <NewInput mask="+99 99 9 9999 9999" label="WhatsApp" name="whatsapp" type="text" placeholder="" value={whatsappNumber} onChange={e => setWhatsappNumber(e.target.value)} />
          </div>
          <div className="padding-inner" style={{ paddingTop: "0px", paddingBottom: "0px" }}>
            <NewInput mask="+99 99 9 9999 9999" label="Facebook" name="facebook" type="text" placeholder="" value={facebookNumber} onChange={e => setFacebookNumber(e.target.value)} />
          </div>
          <div className="padding-inner" style={{ paddingTop: "0px" }}>
            <NewInput mask="+99 99 9 9999 9999" label="Instagram" name="instagram" type="text" placeholder="" value={instagramNumber} onChange={e => setInstagramNumber(e.target.value)} />
          </div>

          <div className="padding-lbr">
            <Button title="Salvar" type="submit" color="green" width="full" loading={false} onClick={() => { }} />
          </div>
        </form>
      </Popup>

      <PopupLastAccesses setLastAccess={setLastAccess} trigger={buttonPopupLastAccesses} setTrigger={setButtonPopupLastAccesses} />

      <div className="customer-container">
        <div className="header flex-separate border-bottom fix-top">
          <span>
            Meus clientes
          </span>

          {/* Pensar nesses filtros futuramente */}
          {/* <div className="navigation">
            <ul className="ml-20">
              <li><a href="customers" onClick={event => { event.preventDefault(); fetchCustomers() }}>Limpar filtros</a></li>
              <li><a href="customers" onClick={event => { event.preventDefault(); setButtonPopupTags(true) }}>Tags</a></li>
              <li><a href="customers" onClick={event => { event.preventDefault(); setButtonPopupSocialMediaFilter(true) }}>Redes sociais</a></li>
              <li><a href="customers" onClick={event => { event.preventDefault(); setButtonPopupLastAccesses(true) }}>Último acesso</a></li>
              <li><a href="customers" onClick={e => advancedFilter(e)}>Filtro avançado</a></li>
              {user.group_id === 8 && <li><button className="dropdown__btn rounded__btn ml-10" style={{ width: "44px", height: "44px" }}
                onClick={() => setAdvancedSearch(true)}>
                <Filter /></button></li>}
            </ul>

            <div className="inner-search ml-20" style={{ height: "45px" }}>
              <div className="search-icon">
                <Search size={24} />
              </div>
              <input className="search-input" onKeyPress={handleSearch} type="text" placeholder="Pressione enter p/ pesquisar" onChange={e => setSearch(e.target.value)} value={search} />
            </div>
          </div> */}
        </div>

        {/*
        NÃO TEM MAIS CLIENTES IMPORTANTES
        {importants.length > 0 && (
          <div className="x-p-20 y-p-20 pb-0">
            <CAlert color="warning">
              <CAlertHeading tag="h4">Clientes importantes!</CAlertHeading>
              {importantLoading && <LoadingCenter />}
              <p>
                {importants?.map((important, index) => {
                  if (index === importants.length - 1) {
                    return (
                      <span className="important__name">
                        {important.name} vence em {important.dataVence}.
                      </span>
                    );
                  } else {
                    return (
                      <span className="important__name">
                        {important.name} vence em {important.dataVence},{" "}
                      </span>
                    );
                  }
                })}
              </p>
              <hr />
              <p className="mb-0">
                Isso é um aviso sinalizando que seus clientes importantes irão ter seus logs vencidos nos próximos 7 dias.
              </p>
            </CAlert>
          </div>
        )} */}

        <div className="table-container">
          {customersLoading ? (
            <LoadingCenter />
          ) : (
            <>
              <CustomerTable
                setTriggers={{ setMediaTrigger, setPhoneTrigger }} setCustomerId={setCustomerId}
                mutations={{ socialMediaMutation, customerHandleMutation }}
                transferCustomer={transferCustomer} customers={customers} selectedCustomer={selectedCustomer} fetchCustomerById={fetchCustomerById} setButtonJoinClients={setButtonJoinClients} setSelectedCustomer={setSelectedCustomer} />
            </>
          )}
        </div>
      </div>

      <div className="customer">
        <div className="header border-left">
          <span>
            Informações
          </span>

          <div>
            {info && info.usadao_id != '' &&
              <a href={`https://usadaomaquinas.com.br/Gerencial_web32yw/PG_Clientes/DashCliente.php?Codigo=` + info.usadao_id} target="_blank">
                <button className="action-btn">
                  <img src={require("../imgs/icon-colored.png")} />
                </button>
              </a>
            }
            {info ?
              (
                <button className="action-btn ml-10" onClick={() => { setButtonPopupLigar(true); pegaCliente(info.id) }}>
                  <Phone />
                </button>
              ) : ("")
            }
          </div>
        </div>

        {info ? (
          <div className="chat-user">
            <div className="box no-bg">
              <div className="box-avatar-wrapper">
                <div className="box-avatar" style={{ backgroundImage: `url(${info.profile_pic})` }}></div>
              </div>
              {info && info.usadao_id != '' && (
                <span className="chat-user-id">#{info.usadao_id}</span>
              )}
              <span className="chat-user-username">{info.nickname}</span>
              <Link to={`/customers/${info.id}`} onClick={e => openCustomersDetails(e, info)} className="chat-user-name">{info.name && info.name}</Link>
              {info.juridic && (<AlertTriangle style={{ color: "red" }} size={18} />)}
              {info.dataAniversario && (
                <span className="chat-user-username">Idade: {info.year} anos</span>)
              }

              {info.ultimaVizualizacao && (
                <span className="chat-user-username">Ultimo login no leilão:</span>)}
              {info.ultimaVizualizacao && (
                <span className="chat-user-id">{moment(info.ultimaVizualizacao).format('LLL')}</span>)}

              {info.city_name && info.state_name && (
                <span className="chat-user-username">{info.city_name} / {info.state_name}</span>)
              }
            </div>

            {info?.usadao_id != "" &&
              <>
                <BoxCustomerMenu user={info} />

                <Box title="Documentos" icon={<Upload size={18} />} onClick={() => inputFilesRef.current.openFiles()} defaultOpen={true}>
                  <DocDropzone ref={inputFilesRef} user={info} />
                </Box>
              </>
            }
            <Box title="Tags" icon={<Edit2 size={18} />} onClick={() => setButtonPopupTagsUser(true)} defaultOpen={true}>
              {info.tags.map((tag, index) =>
                <div key={index} className="tag">
                  <span>#{tag.name}</span>
                </div>
              )}
            </Box>

            <Box title="Observações" icon={<Edit2 size={18} />} onClick={() => setButtonPopupObs(true)} defaultOpen={true}>
              {info?.observations.map((item, index) => {
                return (
                  <div className="observation-box text-color">
                    <div>
                      <span className="observation-box__author">{item.author}</span>
                    </div>
                    <p className="observation-box__body">
                      {item.body}
                    </p>
                  </div>
                );
              })}
            </Box>

            <Box title="Redes sociais" icon={<Edit2 size={18} />} onClick={() => setButtonPopupSocialMedia(true)} defaultOpen={false}>
              {info.socialMedias.map((media, index) => {
                return (
                  <img key={index} src={`${media.icon}`} style={{ marginRight: "10px", marginBottom: "15px" }} />
                )
              })}
            </Box>

            {info && <ChartHours user={info.id} />}

          </div>
        ) : (
          infoLoading ? (
            <LoadingCenter />
          ) : (
            <div className="div-center pt-20 pl-20 pr-20 text-center">
              <Any />
              <span className="chat-user-name">Nenhum cliente</span>
              <span className="chat-user-username">
                Você deve selecionar um cliente para visualizar as informações
              </span>
            </div>
          )
        )}

      </div>
    </div >
  );
}

export default Customers;
